import client from './client';
import { toUnauthorizedError } from 'src/utils/helpers/isUnauthorizedError';

export const runQuery = async (options) => {
	let result;

	try {
		result = await client.query({
			errorPolicy: 'none',
			...options,
		});
	} catch (error) {
		const unauthorizedError = toUnauthorizedError(error);

		if (unauthorizedError) {
			throw unauthorizedError;
		}

		throw error;
	}

	if (result.error) {
		const unauthorizedError = toUnauthorizedError(result.error);

		if (unauthorizedError) {
			throw unauthorizedError;
		}
	}

	return result;
};
